import React, { Component } from 'react';
import Card from '../../components/card/Card';
import Input from '../../inputs/input/Input';
import Button from '../../components/button/Button';
import './DrugCard.scss';
import history from '../../history';
import CreateDrugModal from './createDrugModal/CreateDrugModal';

import DrugList from '../../components/drugList/DrugList';
import CardHeader from '../../components/cardHeader/CardHeader';

class DrugCard extends Component {
	static defaultProps = {
		displayNewDrugButton: true
	};
	constructor(props) {
		super(props);
		this.state = {
			search: '',
			create: false
		};
	}

	_searchChange = (search) => {
		this.setState({ search });
	};

	_navigateToDrugDetailsPage = (drug) => {
		const { id } = drug;
		history.navigate('/drug/' + id);
	};

	_showCreateModal = () => {
		document.querySelector('html').scrollTo({ top: 0, behavior: 'smooth' });
		this.setState({
			create: true
		});
	};

	_closeCreateModal = () => {
		this.setState({ create: false });
	};

	render() {
		const { create } = this.state;
		return (
			<Card className={'g-drug-card'}>
				<div className="top-of-card">
					<CardHeader>{this.props.title || 'Drugs'}</CardHeader>
					<div className="top-of-card-right">
						<Input
              tabIndex={create ? -1:0}
							iconName="icon-search"
							placeholder="Search Type, Lot, Code or Checked By"
							onChange={this._searchChange}
						/>
					</div>
					{this.props.displayNewDrugButton && (<Button onClick={this._showCreateModal} className="top-of-card-right-button" color="white" bg="blue">
						+ New Drug
					</Button>)}
					{this.props.children}
				</div>
				{create && <CreateDrugModal onClose={this._closeCreateModal} />}
				<DrugList
					showUnit={this.props.showUnit}
          tabIndex={create ? -1:0}
					allowUsedDrugs={this.props.allowUsedDrugs}
					drugs={this.props.drugs}
					search={this.state.search}
					onDrugClick={this._navigateToDrugDetailsPage}
				/>
			</Card>
		);
	}
}

export default DrugCard;



// WEBPACK FOOTER //
// ./src/cards/drugCard/DrugCard.jsx